import React, { useState } from "react";
import { useOnScroll } from "../../hooks/useOnScroll";
import { useStyles } from "./navbar.styles";
import logo from "../../assets/logo/normal.svg";
import OutlinedButton from "../../components/buttons/OutlinedButton/OutlinedButton";
import moonImg from "../../assets/svgs/Moon.svg";
import sunImg from "../../assets/svgs/Sun.svg";
import { Link } from "react-scroll";

function NavBar({ toggleTheme, isDarkMode }) {
  const styles = useStyles();
  let shrink = useOnScroll(20);

  const [open, setopen] = useState(false);

  const handle_open = () => {
    setopen(!open);
  };

  const sections = ["Home", "About", "Skills", "Projects", "Contact"];
  return (
    <div>
      <div className={`${styles.navbar} ${shrink && styles.shrink}`}>
        <div className="logo">
          <img src={logo} alt="Farah Dridi" />
        </div>

        <div className={`routes ${open && "opened-navbar"}`}>
          <div className="sections">
            {sections.map((section, index) => {
              return (
                <Link
                  key={index}
                  to={section}
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={1000}
                >
                  <span>{`0${index + 1}.`}</span>
                  {section}
                </Link>
              );
            })}
          </div>
          <OutlinedButton><a href="https://mail.google.com/mail/?view=cm&to=farahdridy@gmail.com" className="button-custom">Hire me</a></OutlinedButton>
          <img
            className={"mode"}
            src={isDarkMode ? moonImg : sunImg}
            onClick={toggleTheme}
            alt="Theme Toggle"
          />
        </div>

        <div
          className={`icon_click ${open && "actived"}`}
          onClick={handle_open}
        >
          <span className="top"></span>
          <span className="mid"></span>
          <span className="bot"></span>
        </div>
      </div>
    </div>
  );
}

export default NavBar;
